import { useEffect } from 'react';

import { GatewayRulesFormValues } from 'pages/GatewayRules/components/GatewayRulesForm/hooks/useGatewayRulesForm';
import { useFormContext, useWatch } from 'react-hook-form';
import { MerchantAccount } from 'types/embedded/merchantAccount';

type Params = {
  mappingIndex: number;
  mappingItemIndex: number;
  accounts: MerchantAccount[];
};

export function useAutoSelectMerchantAccount({ mappingIndex, mappingItemIndex, accounts }: Params) {
  const { control, setValue } = useFormContext<GatewayRulesFormValues>();

  const gatewayWatched = useWatch({
    control,
    name: `mappings.${mappingIndex}.mappingItems.${mappingItemIndex}.gateway`,
  });
  const accountWatched = useWatch({
    control,
    name: `mappings.${mappingIndex}.mappingItems.${mappingItemIndex}.merchantAccount`,
  });

  const canAutoSelect = Boolean(gatewayWatched) && !accountWatched;

  useEffect(() => {
    if (!canAutoSelect || accounts.length !== 1) {
      return;
    }

    setValue(
      `mappings.${mappingIndex}.mappingItems.${mappingItemIndex}.merchantAccount`,
      accounts[0].id,
      { shouldDirty: true, shouldValidate: true },
    );
  }, [accounts, canAutoSelect]);
}
